import { useQuery } from '@tanstack/react-query';

import { DataTable } from '@/components/composed/DataTable/DataTable';
import type { PortalTransaction } from '../schemas/portal';
import { portalTransactionsQuery } from '../api/portal-queries';
import { portalTransactionColumns } from './portal-transaction-columns';

/*
 * Feature component: binds the recent-transactions query + columns to the
 * domain-free DataTable (mirrors InvoiceTable). Read-only — the portal view has
 * no row actions. Data feeds from the mock boundary (portal-queries) in this
 * first pass; see ADR 0009.
 */
export function PortalTransactionsTable() {
  const query = useQuery(portalTransactionsQuery());

  return (
    <DataTable<PortalTransaction>
      columns={portalTransactionColumns}
      data={query.data ?? []}
      getRowId={(row) => row.id}
      tableId="portal-transactions"
      surface
      isLoading={query.isLoading}
      isError={query.isError}
      errorMessage="Failed to load transactions."
      emptyTitle="No transactions yet"
      emptyDescription="Transactions will appear here once billing activity begins."
    />
  );
}
